export const UPLOAD_API_BASE_URI = process.env.REACT_APP_UPLOAD_API__URL;
